import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  CardContent,
  FormControl,
  InputAdornment,
  InputBase,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import {
  PersonOutlineOutlined,
  PlaceOutlined,
  LocalPhoneOutlined,
  EmailOutlined,
  StoreOutlined,
} from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import store, { RootState } from '../../../store/store';
import { saveSellerBuyerDetailsApi } from '../../../store/api/signup';

const BusinessDetails = ({ handleBack, handleNext }: any) => {
  const storeSignupState = useSelector((state: RootState) => state.signup);
  const storeSigninState = useSelector((state: RootState) => state.login);

  const [state] = useState([...Object.keys(storeSigninState.location)]);
  const [district, setDistrict] = useState([]);
  const [businessDetailsData, setBusinessDetailsData] = useState({
    personName: '',
    address: '',
    state: '',
    city: '',
    pincode: '',
    mobileNumber: '',
    emailAddress: '',
    partyGroupName: '',
    // productType: '',
    password: '',
  });

  const handleOnchange = (event: any) => {
    setBusinessDetailsData({
      ...businessDetailsData,
      [event.target.id || event.target.name]: event.target.value,
    });
  };

  const handleContinue = () => {
    const dummy = {
      mobileNumber: '9999999999',
      partyGroupName: 'ABC Society',
      address: 'Plot No 1, Bisrak Road',
      state: 'Uttar Pradesh',
      city: 'Greater Noida',
      pincode: '422001',
      emailAddress: 'ram.kumar@gmail.com',
      personName: 'Ram Kumar',
      panNumber: '',
      tinNumber: '',
      gstNumber: '',
      partyTypeId: 'PARTY_GROUP',
      partyGroupRole: 'SOCIETY',
      personRole: 'SOCIETY_ADMIN',
      password: 'demoadmin',
    };
    const reqBody: any = { ...dummy, ...businessDetailsData };
    store.dispatch(saveSellerBuyerDetailsApi(reqBody)).then((res) => {
      if (res.payload?.status === 200) {
        handleNext();
      }
    });
  };

  return (
    <Box width='100%'>
      <CardContent className='signinContent' sx={{ p: 0, pt: 0.5 }}>
        <Typography variant='h5'>Business Details</Typography>
      </CardContent>

      <Box display='flex' flexDirection={'column'} gap={1}>
        <FormControl sx={{ my: 1.5, width: { xs: '100%', md: '35%' } }}>
          <InputBase
            id='gst-number'
            sx={{
              p: '5px 10px',
              border: '1px solid #DEDEDE',
              borderRadius: 1,
              backgroundColor: '#EEECEC',
            }}
            size='small'
            defaultValue='GST Number- 29GGGGG1314R9Z6'
            disabled
          />
        </FormControl>

        <TextField
          id='personName'
          placeholder='Owner Name'
          size='small'
          sx={{ width: { xs: '100%', md: '35%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <PersonOutlineOutlined fontSize='small' />
              </InputAdornment>
            ),
            autoComplete: 'off',
          }}
          value={businessDetailsData.personName}
          onChange={handleOnchange}
        />

        <FormControl>
          <TextField
            id='address'
            sx={{ width: { xs: '100%', md: '60%' } }}
            multiline
            rows={2}
            placeholder='Address'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <PlaceOutlined fontSize='small' />
                </InputAdornment>
              ),
              autoComplete: 'off',
            }}
            value={businessDetailsData.address}
            onChange={handleOnchange}
          />
        </FormControl>

        <Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} gap={2} sx={{ width: { xs: '100%', md: '60%' } }}>
          <FormControl fullWidth variant='outlined' size='small'>
            <InputLabel id='state'>State</InputLabel>
            <Select
              labelId='state'
              name='state'
              id='state'
              value={businessDetailsData.state}
              onChange={(event) => {
                setDistrict(storeSigninState.location[event.target.value]);
                handleOnchange(event);
              }}
              label='State'
            >
              {state &&
                state.map((el, index) => (
                  <MenuItem key={index} value={el}>
                    {el}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControl fullWidth variant='outlined' size='small'>
            <InputLabel id='city'>City</InputLabel>
            <Select
              labelId='city'
              name='city'
              id='city'
              value={businessDetailsData.city}
              onChange={handleOnchange}
              label='City'
            >
              {district &&
                district.map((el: any) => <MenuItem value={el}>{el}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl sx={{ width: { xs: '100%', md: '50%' } }}>
            <TextField
              id='pincode'
              variant='outlined'
              size='small'
              placeholder='Pin Code'
              value={businessDetailsData.pincode}
              onChange={handleOnchange}
            />
          </FormControl>
        </Box>

        <TextField
          id='mobileNumber'
          placeholder='Contact Number'
          size='small'
          sx={{ width: { xs: '100%', md: '35%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <LocalPhoneOutlined fontSize='small' />
              </InputAdornment>
            ),
            autoComplete: 'off',
          }}
          value={businessDetailsData.mobileNumber}
          onChange={handleOnchange}
        />

        <TextField
          id='emailAddress'
          placeholder='Email Address'
          size='small'
          autoComplete='off'
          sx={{ width: { xs: '100%', md: '35%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <EmailOutlined fontSize='small' />
              </InputAdornment>
            ),
            autoComplete: 'off',
          }}
          value={businessDetailsData.emailAddress}
          onChange={handleOnchange}
        />

        <TextField
          id='partyGroupName'
          placeholder='Business Name'
          size='small'
          sx={{ width: { xs: '100%', md: '35%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <StoreOutlined fontSize='small' />
              </InputAdornment>
            ),
            autoComplete: 'off',
          }}
          value={businessDetailsData.partyGroupName}
          onChange={handleOnchange}
        />
        {/* <TextField
          id='productType'
          placeholder='Product Type'
          size='small'
          sx={{ width: { xs: '100%', md: '35%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <Inventory2Outlined fontSize='small' />
              </InputAdornment>
            ),
            autoComplete: 'off',
          }}
          value={businessDetailsData.productType}
          onChange={handleOnchange}
        /> */}
        <TextField
          id='password'
          placeholder='Password'
          size='small'
          autoComplete='new-password'
          sx={{ width: { xs: '100%', md: '35%' } }}
          InputProps={{
            autoComplete: 'new-password',
          }}
          type='password'
          value={businessDetailsData.password}
          onChange={handleOnchange}
        />

        <Box display={'flex'} gap={3} sx={{ mt: 1 }}>
          {/* <FormControl>
            <Button
              variant='outlined'
              disabled={storeSignupState.loading}
              sx={{ borderRadius: 20, fontWeight: 'bold' }}
              onClick={handleBack}
            >
              BACK
            </Button>
          </FormControl> */}
          <FormControl>
            <LoadingButton
              loading={storeSignupState.loading}
              loadingPosition='center'
              variant='contained'
              sx={{ borderRadius: 20, fontWeight: 'bold' }}
              onClick={handleContinue}
            >
              Update
            </LoadingButton>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

export default BusinessDetails;
